export const noti = {
    text1: "Notificações",
    text2: "Lista de notificações.",
    text3: "Você não tem notificações",
};